import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import genericHelpers from '../_utils/generic-helpers';

function DeliveryOptionFilter({
  selected,
  available,
  onToggle,
  title,
  optionKey,
  unavailable,
}) {
  const handleClick = (e) => {
    e.preventDefault();
    onToggle(optionKey);
  };
  return (
    <li
      className={classNames('options-list-names', {
        selected: selected,
        unavailable: unavailable,
      })}
      key={title}>
      <div
        className={classNames('mr-2 d-flex', 'text-unstyled', {
          selected: selected,
          disabled: !available,
        })}>
        <label htmlFor={title} className="m-0">
          <input
            type="radio"
            id={title}
            className={classNames('mr-2 black-radio-button', {
              selected: selected,
              disabled: !available,
            })}
            onChange={handleClick}
            checked={selected}
            aria-label={title}></input>
          {genericHelpers.tidyTitleFilter(title)}
        </label>
      </div>
    </li>
  );
}

DeliveryOptionFilter.propTypes = {
  selected: PropTypes.bool,
  available: PropTypes.bool,
  unavailable: PropTypes.bool,
  onToggle: PropTypes.func,
  title: PropTypes.string.isRequired,
  optionKey: PropTypes.number,
};

export default DeliveryOptionFilter;
